import { getServicesBaseUrl } from "../../helpers/apiEnv"
import React, { useState, useEffect } from "react";
import axios from "axios";
import {
    Row, Col, Card, CardBody, CardHeader, Form, FormGroup, Label,
    Nav, NavItem, NavLink, TabContent, TabPane, Button, Spinner,
    Badge, Table, Progress, Modal, ModalHeader, ModalBody, Input,
} from "reactstrap";
import Select from "react-select";
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactApexChart from "react-apexcharts";

const baseURL = process.env.REACT_APP_API_URL;
//const newAPIURL = "http://localhost:3100/a2/api/v1";
const newAPIURL = getServicesBaseUrl().replace(/\/+$/, ""); // dinámico: respeta Prod/QA

// Helper: fecha local como YYYY-MM-DD (evita desfase UTC)
const toLocalDateString = (date) => {
    if (!date) return null;
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
};

// ─── Utilidades ──────────────────────────────────────────────────
const fmtCur = (v) => {
    if (v == null || isNaN(v)) return "$0";
    return new Intl.NumberFormat("es-CO", { style: "currency", currency: "COP", minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(v);
};
const fmtNum = (v) => (v == null || isNaN(v)) ? "0" : new Intl.NumberFormat("es-CO").format(v);
const fmtPct = (v) => (v == null || isNaN(v)) ? "0%" : `${Number(v).toFixed(1)}%`;

// ─── Colores ─────────────────────────────────────────────────────
const COLORS = ["#2196F3", "#4CAF50", "#FF9800", "#9C27B0", "#f44336", "#00BCD4", "#795548", "#607D8B", "#E91E63", "#3F51B5", "#CDDC39", "#FF5722", "#009688", "#673AB7", "#8BC34A"];
const pickColor = (i) => COLORS[i % COLORS.length];

// ─── Micro-componentes ──────────────────────────────────────────
const Kpi = ({ icon, title, value, sub, color }) => (
    <Card className="shadow-sm" style={{ borderLeft: `4px solid ${color}`, minHeight: 110 }}>
        <CardBody className="p-3">
            <div className="d-flex align-items-center">
                <div className="me-3" style={{ width: 46, height: 46, borderRadius: "50%", background: `${color}1A`, display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <i className={`mdi ${icon}`} style={{ fontSize: 22, color }} />
                </div>
                <div>
                    <p className="text-muted fw-medium mb-1" style={{ fontSize: 11, letterSpacing: .5 }}>{title}</p>
                    <h5 className="mb-0 fw-bold" style={{ color }}>{value}</h5>
                    {sub && <small className="text-muted">{sub}</small>}
                </div>
            </div>
        </CardBody>
    </Card>
);

const ConcBadge = ({ tipo }) => {
    const map = { Alta: { bg: "#f4433620", c: "#f44336", ic: "mdi-alert-circle" }, Media: { bg: "#FF980020", c: "#FF9800", ic: "mdi-alert" }, Baja: { bg: "#4CAF5020", c: "#4CAF50", ic: "mdi-check-circle" } };
    const m = map[tipo] || map.Media;
    return (
        <span style={{ background: m.bg, color: m.c, border: `1px solid ${m.c}55`, borderRadius: 20, padding: "5px 13px", fontSize: 13, fontWeight: 600, display: "inline-flex", alignItems: "center", gap: 4 }}>
            <i className={`mdi ${m.ic}`} style={{ fontSize: 15 }} />{tipo}
        </span>
    );
};

// ══════════════════════════════════════════════════════════════════
//  COMPONENTE PRINCIPAL
// ══════════════════════════════════════════════════════════════════
const MapaConsumo = (props) => {
    document.title = "Mapa de Consumo | LS-DA";

    const storedUser = localStorage.getItem("authUser");
    const currentUser = storedUser ? JSON.parse(storedUser) : null;

    // ── State ──
    const [empresas, setEmpresas] = useState([]);
    const [sucursales, setSucursales] = useState([]);
    const [nitemisor, setNitemisor] = useState("");
    const [fechaRango, setFechaRango] = useState([new Date(), new Date()]);
    const [fechaInicio, fechaFin] = fechaRango;
    const [selectedSucursal, setSelectedSucursal] = useState("");
    const [nitreceptor, setNitreceptor] = useState("");
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadingExcel, setLoadingExcel] = useState(false);
    const [loadingPdf, setLoadingPdf] = useState(false);

    // Tabs
    const [activeTab, setActiveTab] = useState("dashboard");
    // Modal
    const [selProducto, setSelProducto] = useState(null);
    const [modal, setModal] = useState(false);
    // Modal receptor
    const [selReceptor, setSelReceptor] = useState(null);
    const [modalRec, setModalRec] = useState(false);

    // ── Empresas — no longer needed, NIT comes from empresaSeleccionada ──
    const fetchEmpresas = async () => { };

    // ── Sucursales ──
    const fetchSucursales = async (nit) => {
        if (!nit) { setSucursales([]); return; }
        try {
            const r = await axios.get(`${newAPIURL}/analytics/estructura-organizacional?nitemisor=${nit}`, { headers: { "Content-Type": "application/json" } });
            setSucursales(r.data.success && r.data.data ? (r.data.data.sucursales || []) : []);
        } catch { setSucursales([]); }
    };

    useEffect(() => {
        const su = localStorage.getItem("authUser");
        const cu = su ? JSON.parse(su) : null;
        if (cu) {
            props.setBreadcrumbItems(
                `Bienvenido, ${cu.usuario?.nombre || ''} ${cu.usuario?.apellido || ''}`,
                [{ title: "LS-DA", link: "#" }, { title: "Mercadeo", link: "#" }, { title: "Mapa de Consumo", link: "#" }]
            );
        }
        // Auto-select empresa from header
        const storedEmpresa = localStorage.getItem("empresaSeleccionada")
        if (storedEmpresa) {
            try {
                const emp = JSON.parse(storedEmpresa)
                const nit = emp?.nit || emp?.identificacion || ""
                if (nit) {
                    setNitemisor(nit)
                    fetchSucursales(nit)
                }
            } catch (e) { /* ignore */ }
        }
    }, []); // eslint-disable-line

    // React to empresa change from header selector
    useEffect(() => {
        if (props.empresaSeleccionada) {
            const nit = props.empresaSeleccionada.nit || props.empresaSeleccionada.identificacion || ""
            if (nit && nit !== nitemisor) {
                setNitemisor(nit)
                fetchSucursales(nit)
                setData(null)
                setSelectedSucursal("")
            }
        }
    }, [props.empresaSeleccionada]) // eslint-disable-line

    const empresaOpts = empresas.map((e) => {
        const isSA = currentUser && currentUser.role === "SuperAdmin";
        return { value: isSA ? e.identificacion : e.idempresa.identificacion, label: isSA ? e.nombre : e.idempresa.nombre };
    });
    const sucursalOpts = [{ value: "", label: "Todas las sucursales" }, ...sucursales.map((s) => ({ value: s.sucursal, label: s.sucursal }))];

    // ── Fetch Mapa de Consumo ──
    const fetchData = async () => {
        if (!nitemisor) { alert("Seleccione una empresa."); return; }
        if (!fechaInicio || !fechaFin) { alert("Seleccione el rango de fechas."); return; }
        setLoading(true); setData(null);

        try {
            const p = { nitemisor, fecha_inicio: toLocalDateString(fechaInicio), fecha_fin: toLocalDateString(fechaFin) };
            if (selectedSucursal) p.sucursal = selectedSucursal;
            if (nitreceptor.trim()) p.nitreceptor = nitreceptor.trim();
            const r = await axios.get(`${newAPIURL}/analytics/receptores/mapa-consumo`, { params: p, headers: { "Content-Type": "application/json" } });
            if (r.data.success) setData(r.data);
            else alert(`Error: ${r.data.error || "Error desconocido"}`);
        } catch (e) {
            console.error(e);
            alert("Error al consultar mapa de consumo. Verifique su conexión.");
        } finally { setLoading(false); }
    };

    const limpiar = () => { setFechaRango([new Date(), new Date()]); setSelectedSucursal(""); setNitreceptor(""); setData(null); };

    // ── Descargar Excel ──
    const descargarExcel = async () => {
        if (!nitemisor || !fechaInicio || !fechaFin) { alert("Seleccione empresa y fechas."); return; }
        setLoadingExcel(true);
        try {
            const fi = toLocalDateString(fechaInicio);
            const ff = toLocalDateString(fechaFin);
            let url = `${newAPIURL}/export/mapa-consumo-excel?nitemisor=${nitemisor}&fecha_inicio=${fi}&fecha_fin=${ff}`;
            if (selectedSucursal) url += `&sucursal=${encodeURIComponent(selectedSucursal)}`;
            if (nitreceptor.trim()) url += `&nitreceptor=${encodeURIComponent(nitreceptor.trim())}`;
            const r = await axios.get(url, { responseType: "blob" });
            const blob = new Blob([r.data], { type: r.headers["content-type"] || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            const cd = r.headers["content-disposition"];
            link.download = cd ? cd.split("filename=")[1]?.replace(/"/g, "") || `MapaConsumo_${nitemisor}.xlsx` : `MapaConsumo_${nitemisor}.xlsx`;
            document.body.appendChild(link); link.click(); link.remove(); URL.revokeObjectURL(link.href);
        } catch (e) { console.error(e); alert("Error al descargar Excel."); }
        finally { setLoadingExcel(false); }
    };

    // ── Descargar PDF ──
    const descargarPdf = async () => {
        if (!nitemisor || !fechaInicio || !fechaFin) { alert("Seleccione empresa y fechas."); return; }
        setLoadingPdf(true);
        try {
            const fi = toLocalDateString(fechaInicio);
            const ff = toLocalDateString(fechaFin);
            let url = `${newAPIURL}/export/mapa-consumo-pdf?nitemisor=${nitemisor}&fecha_inicio=${fi}&fecha_fin=${ff}`;
            if (selectedSucursal) url += `&sucursal=${encodeURIComponent(selectedSucursal)}`;
            if (nitreceptor.trim()) url += `&nitreceptor=${encodeURIComponent(nitreceptor.trim())}`;
            const r = await axios.get(url, { responseType: "text" });
            const w = window.open("", "_blank", "width=1100,height=800,scrollbars=yes,resizable=yes");
            if (!w) { alert("Permita las ventanas emergentes."); return; }
            w.document.open(); w.document.write(r.data); w.document.close();
            const btn = w.document.createElement("div");
            btn.style.cssText = "position:fixed;top:12px;right:12px;z-index:99999;display:flex;gap:8px;";
            btn.innerHTML = '<button onclick="window.print()" style="padding:8px 18px;background:#1976D2;color:#fff;border:none;border-radius:6px;font-size:14px;font-weight:600;cursor:pointer;box-shadow:0 2px 8px rgba(0,0,0,.15)">🖨 Imprimir / PDF</button>'
                + '<button onclick="window.close()" style="padding:8px 14px;background:#f5f5f5;color:#333;border:1px solid #ddd;border-radius:6px;font-size:14px;cursor:pointer">✕ Cerrar</button>';
            w.document.body.appendChild(btn);
            const st = w.document.createElement("style");
            st.textContent = "@media print { div[style*='position:fixed'] { display:none !important; } }";
            w.document.head.appendChild(st);
        } catch (e) { console.error(e); alert("Error al generar reporte PDF."); }
        finally { setLoadingPdf(false); }
    };

    // ══════════════════════════════════════════════════════════════
    //  CHART BUILDERS
    // ══════════════════════════════════════════════════════════════

    // Top 15 productos bar horizontal
    const topProdBar = () => {
        if (!data?.matriz_producto_sucursal) return null;
        const t = (data.matriz_producto_sucursal || []).slice(0, 15);
        return {
            series: [{ name: "Ventas", data: t.map(p => Math.round(p.total_general)) }],
            options: {
                chart: { type: "bar", toolbar: { show: false }, fontFamily: "inherit" },
                plotOptions: { bar: { borderRadius: 4, horizontal: true, barHeight: "65%", distributed: true } },
                colors: t.map((_, i) => pickColor(i)),
                dataLabels: { enabled: true, formatter: v => fmtCur(v), style: { fontSize: "11px" } },
                xaxis: { categories: t.map(p => p.descripcion.length > 30 ? p.descripcion.substring(0, 30) + "…" : p.descripcion), labels: { formatter: v => fmtCur(v) } },
                yaxis: { labels: { style: { fontSize: "11px" }, maxWidth: 220 } },
                legend: { show: false },
                tooltip: { y: { formatter: v => fmtCur(v) } },
                grid: { borderColor: "#f1f1f1" },
            }
        };
    };

    // Treemap productos
    const prodTreemap = () => {
        if (!data?.matriz_producto_sucursal) return null;
        return {
            series: [{ data: (data.matriz_producto_sucursal || []).slice(0, 25).map(p => ({ x: p.descripcion.length > 22 ? p.descripcion.substring(0, 22) + "…" : p.descripcion, y: Math.round(p.total_general) })) }],
            options: {
                chart: { type: "treemap", toolbar: { show: false }, fontFamily: "inherit" },
                colors: COLORS,
                plotOptions: { treemap: { distributed: true, enableShades: false } },
                dataLabels: { enabled: true, formatter: (text, op) => [text, fmtCur(op.value)], style: { fontSize: "11px" } },
                tooltip: { y: { formatter: v => fmtCur(v) } },
            }
        };
    };

    // Curva de Pareto
    const paretoChart = () => {
        if (!data?.concentracion_ingresos?.curva_pareto) return null;
        const cp = data.concentracion_ingresos.curva_pareto;
        return {
            series: [
                { name: "% Acum. Ventas (Real)", data: cp.map(p => Math.round(p.pct_acumulado_ventas * 10) / 10), type: "area" },
                { name: "Línea Equidad", data: cp.map(p => Math.round(p.pct_acumulado_receptores * 10) / 10), type: "line" },
            ],
            options: {
                chart: { toolbar: { show: false }, fontFamily: "inherit", zoom: { enabled: false } },
                stroke: { width: [3, 2], curve: "smooth", dashArray: [0, 5] },
                colors: ["#2196F3", "#e0e0e0"],
                fill: { type: ["gradient", "solid"], gradient: { shadeIntensity: 1, opacityFrom: 0.35, opacityTo: 0.05 } },
                xaxis: { categories: cp.map(p => `${Math.round(p.pct_acumulado_receptores)}%`), title: { text: "% Acumulado de Clientes" }, labels: { style: { fontSize: "11px" } } },
                yaxis: { title: { text: "% Acumulado de Ventas" }, labels: { formatter: v => `${v}%` }, max: 100 },
                legend: { position: "top" },
                tooltip: { y: { formatter: v => `${v}%` } },
                annotations: { yaxis: [{ y: 80, borderColor: "#f44336", strokeDashArray: 4, label: { text: "80% Ventas", style: { color: "#f44336", fontSize: "11px" } } }] },
                grid: { borderColor: "#f1f1f1" },
            }
        };
    };

    // Cobertura donut
    const coberturaDonut = () => {
        if (!data?.cobertura_geografica) return null;
        const cg = data.cobertura_geografica;
        return {
            series: [cg.receptores_multi_sucursal, cg.receptores_uni_sucursal],
            options: {
                chart: { type: "donut", fontFamily: "inherit" },
                labels: ["Multi-sucursal", "Uni-sucursal"],
                colors: ["#2196F3", "#FF9800"],
                legend: { position: "bottom", fontSize: "13px" },
                plotOptions: { pie: { donut: { size: "62%", labels: { show: true, total: { show: true, label: "Receptores", formatter: () => cg.total_receptores } } } } },
                dataLabels: { enabled: true, formatter: (val) => `${val.toFixed(1)}%`, style: { fontSize: "12px" } },
                tooltip: { y: { formatter: v => `${v} clientes` } },
            }
        };
    };

    // Heatmap Producto-Sucursal (top 12 productos, todas las sucursales)
    const heatmapProdSuc = () => {
        if (!data?.matriz_producto_sucursal) return null;
        const prods = (data.matriz_producto_sucursal || []).slice(0, 12);
        // collect all unique sucursales
        const allSucs = new Set();
        prods.forEach(p => (p.ventas_por_sucursal || []).forEach(s => allSucs.add(s.sucursal)));
        const sucList = [...allSucs];
        if (!sucList.length) return null;

        const series = sucList.map(suc => ({
            name: suc.length > 15 ? suc.substring(0, 15) + "…" : suc,
            data: prods.map(p => {
                const match = (p.ventas_por_sucursal || []).find(v => v.sucursal === suc);
                return { x: p.descripcion.length > 18 ? p.descripcion.substring(0, 18) + "…" : p.descripcion, y: match ? Math.round(match.importe) : 0 };
            })
        }));

        return {
            series,
            options: {
                chart: { type: "heatmap", toolbar: { show: false }, fontFamily: "inherit" },
                dataLabels: { enabled: true, formatter: v => v > 0 ? fmtCur(v) : "", style: { fontSize: "10px", fontWeight: 600 } },
                colors: ["#2196F3"],
                plotOptions: {
                    heatmap: {
                        shadeIntensity: 0.7, colorScale: {
                            ranges: [
                                { from: 0, to: 0, name: "Sin ventas", color: "#f5f5f5" },
                                { from: 1, to: 500000, name: "< 500K", color: "#BBDEFB" },
                                { from: 500001, to: 2000000, name: "500K-2M", color: "#64B5F6" },
                                { from: 2000001, to: 5000000, name: "2M-5M", color: "#1E88E5" },
                                { from: 5000001, to: 999999999, name: "> 5M", color: "#0D47A1" },
                            ]
                        }
                    }
                },
                xaxis: { labels: { style: { fontSize: "10px" }, rotateAlways: true, rotate: -45 } },
                legend: { position: "top" },
                tooltip: { y: { formatter: v => fmtCur(v) } },
            }
        };
    };

    // ══════════════════════════════════════════════════════════════
    //  TAB: DASHBOARD
    // ══════════════════════════════════════════════════════════════
    const renderDashboard = () => {
        if (!data || !data.matriz_producto_sucursal) return null;
        const mat = data.matriz_producto_sucursal || [];
        const conc = data.concentracion_ingresos || {};
        const cob = data.cobertura_geografica || {};
        const cross = data.oportunidades_cross_sell || [];

        const totalVentas = mat.reduce((s, p) => s + (p.total_general || 0), 0);
        const totalProductos = mat.length;

        const pareto = paretoChart();
        const cobDonut = coberturaDonut();

        return (<>
            {/* KPIs */}
            <Row className="mb-3">
                <Col md={3} sm={6} className="mb-3"><Kpi icon="mdi-package-variant-closed" title="PRODUCTOS ANALIZADOS" value={fmtNum(totalProductos)} sub={`Periodo: ${data.periodo}`} color="#2196F3" /></Col>
                <Col md={3} sm={6} className="mb-3"><Kpi icon="mdi-cash-multiple" title="VENTAS TOTALES" value={fmtCur(totalVentas)} sub={`${fmtNum(conc.total_receptores || cob.total_receptores || 0)} receptores`} color="#4CAF50" /></Col>
                <Col md={3} sm={6} className="mb-3"><Kpi icon="mdi-account-group" title="COBERTURA" value={`${fmtPct(cob.pct_multi_sucursal)} multi-suc.`} sub={`Prom: ${(cob.promedio_sucursales_por_receptor || 0).toFixed(1)} suc/cliente`} color="#FF9800" /></Col>
                <Col md={3} sm={6} className="mb-3"><Kpi icon="mdi-chart-bell-curve" title="CONCENTRACIÓN" value={<><span style={{ marginRight: 8 }}>{`Gini: ${(conc.indice_gini || 0).toFixed(2)}`}</span><ConcBadge tipo={conc.tipo_concentracion || "N/A"} /></>} sub={`${conc.pct_receptores_para_80pct_ventas || 0}% genera 80% ventas`} color="#9C27B0" /></Col>
            </Row>

            {/* Insights */}
            <Row className="mb-3"><Col>
                <Card className="shadow-sm"><CardBody>
                    <div className="d-flex align-items-center mb-3">
                        <div style={{ width: 34, height: 34, borderRadius: "50%", background: "#E3F2FD", display: "flex", alignItems: "center", justifyContent: "center", marginRight: 10 }}>
                            <i className="mdi mdi-lightbulb-on" style={{ fontSize: 18, color: "#1976D2" }} />
                        </div>
                        <h6 className="mb-0 fw-bold">Insights Clave</h6>
                    </div>
                    <Row>
                        {(data.insights || []).map((t, i) => (
                            <Col md={6} key={i}>
                                <div className="d-flex align-items-start mb-2 p-2" style={{ background: "#F5F5F5", borderRadius: 8, borderLeft: "3px solid #2196F3" }}>
                                    <i className="mdi mdi-chart-bubble me-2 mt-1" style={{ color: "#2196F3", fontSize: 15 }} />
                                    <span style={{ fontSize: 13 }}>{t}</span>
                                </div>
                            </Col>
                        ))}
                    </Row>
                </CardBody></Card>
            </Col></Row>

            {/* Pareto + Cobertura */}
            <Row className="mb-3">
                <Col md={7} className="mb-3"><Card className="shadow-sm h-100"><CardBody>
                    <h6 className="fw-bold mb-3"><i className="mdi mdi-chart-line me-1 text-primary" />Curva de Pareto — Concentración de Ingresos</h6>
                    <div className="d-flex gap-3 mb-2 flex-wrap">
                        <small className="text-muted"><strong>Top 10%:</strong> {fmtPct(conc.top_10_pct_ventas)} ventas</small>
                        <small className="text-muted"><strong>Top 20%:</strong> {fmtPct(conc.top_20_pct_ventas)} ventas</small>
                        <small className="text-muted"><strong>80% ventas:</strong> {conc.receptores_que_generan_80pct} receptores ({fmtPct(conc.pct_receptores_para_80pct_ventas)})</small>
                    </div>
                    {pareto && <ReactApexChart options={pareto.options} series={pareto.series} type="area" height={320} />}
                </CardBody></Card></Col>
                <Col md={5} className="mb-3"><Card className="shadow-sm h-100"><CardBody>
                    <h6 className="fw-bold mb-3"><i className="mdi mdi-store-marker me-1 text-warning" />Cobertura Geográfica</h6>
                    {cobDonut && <ReactApexChart options={cobDonut.options} series={cobDonut.series} type="donut" height={280} />}
                    <div className="text-center mt-2">
                        <Badge color="info" pill className="me-2 px-3 py-2">{fmtNum(cob.receptores_multi_sucursal)} multi-sucursal</Badge>
                        <Badge color="warning" pill className="px-3 py-2">{fmtNum(cob.receptores_uni_sucursal)} uni-sucursal</Badge>
                    </div>
                </CardBody></Card></Col>
            </Row>

            {/* Oportunidades Cross-Sell (resumen) */}
            {cross.length > 0 && (
                <Row className="mb-3"><Col><Card className="shadow-sm"><CardBody>
                    <h6 className="fw-bold mb-3"><i className="mdi mdi-swap-horizontal-bold me-1 text-success" />Oportunidades de Cross-Sell <Badge color="success" pill className="ms-2">{cross.length}</Badge></h6>
                    <div className="table-responsive" style={{ maxHeight: 300, overflowY: "auto" }}>
                        <Table size="sm" className="table-hover mb-0 align-middle">
                            <thead style={{ position: "sticky", top: 0, background: "#fff", zIndex: 1 }}>
                                <tr><th style={{ fontSize: 11 }}>Cliente</th><th style={{ fontSize: 11 }}>Producto Sugerido</th><th style={{ fontSize: 11 }}>Razón</th><th className="text-center" style={{ fontSize: 11 }}>Probab.</th></tr>
                            </thead>
                            <tbody>
                                {cross.slice(0, 20).map((o, i) => (
                                    <tr key={i}>
                                        <td style={{ fontSize: 12 }}><div className="fw-bold">{o.nombrereceptor}</div><small className="text-muted">{o.nitreceptor}</small></td>
                                        <td style={{ fontSize: 12 }}><div className="fw-bold">{o.descripcion_producto}</div><small className="text-muted">Cód: {o.producto_sugerido}</small></td>
                                        <td style={{ fontSize: 11 }}>{o.razon_sugerencia}</td>
                                        <td className="text-center"><Badge color={o.probabilidad_compra_pct >= 50 ? "success" : o.probabilidad_compra_pct >= 30 ? "warning" : "secondary"} pill>{o.probabilidad_compra_pct}%</Badge></td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </CardBody></Card></Col></Row>
            )}
        </>);
    };

    // ══════════════════════════════════════════════════════════════
    //  TAB: MATRIZ PRODUCTO-SUCURSAL
    // ══════════════════════════════════════════════════════════════
    const renderMatriz = () => {
        if (!data?.matriz_producto_sucursal) return null;
        const mat = data.matriz_producto_sucursal || [];
        const tb = topProdBar();
        const tm = prodTreemap();
        const hm = heatmapProdSuc();

        return (<>
            {/* Top productos bar */}
            {tb && <Row className="mb-3"><Col><Card className="shadow-sm"><CardBody>
                <h6 className="fw-bold mb-3"><i className="mdi mdi-podium-gold me-1 text-warning" />Top {Math.min(15, mat.length)} Productos por Ventas</h6>
                <ReactApexChart options={tb.options} series={tb.series} type="bar" height={Math.max(350, Math.min(15, mat.length) * 38)} />
            </CardBody></Card></Col></Row>}

            {/* Heatmap producto-sucursal */}
            {hm && <Row className="mb-3"><Col><Card className="shadow-sm"><CardBody>
                <h6 className="fw-bold mb-3"><i className="mdi mdi-grid me-1 text-info" />Heatmap Producto × Sucursal (Top 12)</h6>
                <ReactApexChart options={hm.options} series={hm.series} type="heatmap" height={Math.max(250, hm.series.length * 60)} />
            </CardBody></Card></Col></Row>}

            {/* Treemap */}
            {tm && <Row className="mb-3"><Col><Card className="shadow-sm"><CardBody>
                <h6 className="fw-bold mb-3"><i className="mdi mdi-view-dashboard me-1 text-primary" />Mapa de Participación de Productos</h6>
                <ReactApexChart options={tm.options} series={tm.series} type="treemap" height={350} />
            </CardBody></Card></Col></Row>}

            {/* Tabla detallada */}
            <Row className="mb-3"><Col><Card className="shadow-sm"><CardBody>
                <h6 className="fw-bold mb-3"><i className="mdi mdi-table me-1 text-dark" />Detalle Matriz Producto-Sucursal</h6>
                <div className="table-responsive" style={{ maxHeight: 500, overflowY: "auto" }}>
                    <Table size="sm" className="table-hover mb-0 align-middle">
                        <thead style={{ position: "sticky", top: 0, background: "#F5F7FA", zIndex: 1 }}>
                            <tr>
                                <th style={{ fontSize: 11 }}>Producto</th>
                                <th className="text-end" style={{ fontSize: 11 }}>Venta Total</th>
                                <th className="text-center" style={{ fontSize: 11 }}>Cant.</th>
                                <th style={{ fontSize: 11 }}>Sucursales</th>
                                <th style={{ width: 40 }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {mat.map((p, i) => (
                                <tr key={i} style={{ cursor: "pointer" }} onClick={() => { setSelProducto(p); setModal(true); }}>
                                    <td><div className="fw-bold" style={{ fontSize: 12 }}>{p.descripcion}</div><small className="text-muted">Cód: {p.codigo_producto}</small></td>
                                    <td className="text-end fw-bold" style={{ fontSize: 12, color: "#4CAF50" }}>{fmtCur(p.total_general)}</td>
                                    <td className="text-center" style={{ fontSize: 12 }}>{fmtNum(p.cantidad_general)}</td>
                                    <td>
                                        <div className="d-flex gap-1 flex-wrap">
                                            {(p.ventas_por_sucursal || []).map((s, si) => (
                                                <Badge key={si} color="light" className="text-dark" style={{ fontSize: 10 }}>{s.sucursal} ({fmtPct(s.porcentaje_del_producto)})</Badge>
                                            ))}
                                        </div>
                                    </td>
                                    <td><i className="mdi mdi-chevron-right text-muted" style={{ fontSize: 18 }} /></td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </CardBody></Card></Col></Row>
        </>);
    };

    // ══════════════════════════════════════════════════════════════
    //  TAB: TOP PRODUCTOS POR RECEPTOR
    // ══════════════════════════════════════════════════════════════
    const renderTopReceptores = () => {
        if (!data?.top_productos_por_receptor) return null;
        const receptores = data.top_productos_por_receptor || [];

        return (<>
            <Row>
                {receptores.map((rec, ri) => (
                    <Col lg={6} key={ri} className="mb-4">
                        <Card className="shadow-sm h-100" style={{ borderTop: `4px solid ${pickColor(ri)}`, cursor: "pointer", transition: "transform .2s, box-shadow .2s" }}
                            onClick={() => { setSelReceptor(rec); setModalRec(true); }}
                            onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-3px)"; e.currentTarget.style.boxShadow = "0 8px 25px rgba(0,0,0,.12)"; }}
                            onMouseLeave={e => { e.currentTarget.style.transform = ""; e.currentTarget.style.boxShadow = ""; }}>
                            <CardBody>
                                <div className="d-flex align-items-center mb-3">
                                    <div style={{ width: 42, height: 42, borderRadius: "50%", background: `${pickColor(ri)}22`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                        <i className="mdi mdi-account-circle" style={{ fontSize: 22, color: pickColor(ri) }} />
                                    </div>
                                    <div className="ms-2 flex-grow-1" style={{ minWidth: 0 }}>
                                        <h6 className="mb-0 fw-bold text-truncate" style={{ fontSize: 13 }}>{rec.nombrereceptor}</h6>
                                        <small className="text-muted">NIT: {rec.nitreceptor}</small>
                                    </div>
                                    <div className="text-end">
                                        <div className="fw-bold" style={{ color: "#4CAF50", fontSize: 14 }}>{fmtCur(rec.total_compras)}</div>
                                        <small className="text-muted">{(rec.productos || []).length} productos</small>
                                    </div>
                                </div>

                                {/* Top 5 productos mini */}
                                <div className="table-responsive">
                                    <Table size="sm" className="mb-0">
                                        <thead><tr style={{ fontSize: 10, textTransform: "uppercase" }}><th>Producto</th><th className="text-end">Importe</th><th className="text-center">%</th></tr></thead>
                                        <tbody>
                                            {(rec.productos || []).slice(0, 5).map((p, pi) => (
                                                <tr key={pi}>
                                                    <td style={{ fontSize: 11 }}>{p.descripcion}</td>
                                                    <td className="text-end fw-bold" style={{ fontSize: 11 }}>{fmtCur(p.importe_total)}</td>
                                                    <td className="text-center"><Badge color="info" pill style={{ fontSize: 9 }}>{fmtPct(p.participacion_gasto_pct)}</Badge></td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                                {(rec.productos || []).length > 5 && <div className="text-center mt-2"><small className="text-primary fw-bold"><i className="mdi mdi-eye me-1" />Ver {rec.productos.length - 5} más…</small></div>}
                            </CardBody>
                        </Card>
                    </Col>
                ))}
            </Row>
        </>);
    };

    // ══════════════════════════════════════════════════════════════
    //  TAB: COBERTURA GEOGRÁFICA
    // ══════════════════════════════════════════════════════════════
    const renderCobertura = () => {
        if (!data?.cobertura_geografica) return null;
        const cob = data.cobertura_geografica;
        const detalle = cob.detalle || [];
        const multi = detalle.filter(d => d.tipo === "multi_sucursal");
        const uni = detalle.filter(d => d.tipo === "uni_sucursal");
        const cobDonut = coberturaDonut();

        return (<>
            {/* KPIs cobertura */}
            <Row className="mb-3">
                <Col md={3} sm={6} className="mb-3"><Kpi icon="mdi-account-group" title="TOTAL RECEPTORES" value={fmtNum(cob.total_receptores)} color="#2196F3" /></Col>
                <Col md={3} sm={6} className="mb-3"><Kpi icon="mdi-store-marker" title="MULTI-SUCURSAL" value={fmtNum(cob.receptores_multi_sucursal)} sub={fmtPct(cob.pct_multi_sucursal)} color="#4CAF50" /></Col>
                <Col md={3} sm={6} className="mb-3"><Kpi icon="mdi-store" title="UNI-SUCURSAL" value={fmtNum(cob.receptores_uni_sucursal)} color="#FF9800" /></Col>
                <Col md={3} sm={6} className="mb-3"><Kpi icon="mdi-chart-line-variant" title="PROM. SUC/CLIENTE" value={(cob.promedio_sucursales_por_receptor || 0).toFixed(2)} color="#9C27B0" /></Col>
            </Row>

            {/* Donut */}
            {cobDonut && <Row className="mb-3"><Col md={5} className="mb-3"><Card className="shadow-sm h-100"><CardBody>
                <h6 className="fw-bold mb-3"><i className="mdi mdi-chart-donut me-1 text-primary" />Distribución de Cobertura</h6>
                <ReactApexChart options={cobDonut.options} series={cobDonut.series} type="donut" height={300} />
            </CardBody></Card></Col>

                {/* Multi-sucursal destacados */}
                <Col md={7} className="mb-3"><Card className="shadow-sm h-100"><CardBody>
                    <h6 className="fw-bold mb-3"><i className="mdi mdi-store-marker me-1 text-success" />Clientes Multi-Sucursal <Badge color="success" pill>{multi.length}</Badge></h6>
                    <div className="table-responsive" style={{ maxHeight: 320, overflowY: "auto" }}>
                        <Table size="sm" className="table-hover mb-0 align-middle">
                            <thead style={{ position: "sticky", top: 0, background: "#fff", zIndex: 1 }}>
                                <tr><th style={{ fontSize: 11 }}>Cliente</th><th className="text-end" style={{ fontSize: 11 }}>Compras</th><th className="text-center" style={{ fontSize: 11 }}>#Suc</th><th style={{ fontSize: 11 }}>Sucursales</th></tr>
                            </thead>
                            <tbody>
                                {multi.slice(0, 30).map((d, i) => (
                                    <tr key={i}>
                                        <td><div className="fw-bold" style={{ fontSize: 12 }}>{d.nombrereceptor}</div><small className="text-muted">{d.nitreceptor}</small></td>
                                        <td className="text-end fw-bold" style={{ fontSize: 12, color: "#4CAF50" }}>{fmtCur(d.total_compras)}</td>
                                        <td className="text-center"><Badge color="info" pill>{d.num_sucursales}</Badge></td>
                                        <td><div className="d-flex gap-1 flex-wrap">{(d.sucursales || []).map((s, si) => <Badge key={si} color="light" className="text-dark" style={{ fontSize: 10 }}>{s}</Badge>)}</div></td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </CardBody></Card></Col></Row>}

            {/* Tabla completa detalle */}
            <Row className="mb-3"><Col><Card className="shadow-sm"><CardBody>
                <h6 className="fw-bold mb-3"><i className="mdi mdi-format-list-bulleted me-1" />Detalle Completo de Cobertura ({detalle.length} receptores)</h6>
                <div className="table-responsive" style={{ maxHeight: 450, overflowY: "auto" }}>
                    <Table size="sm" className="table-hover mb-0 align-middle">
                        <thead style={{ position: "sticky", top: 0, background: "#F5F7FA", zIndex: 1 }}>
                            <tr><th style={{ fontSize: 11 }}>Cliente</th><th className="text-end" style={{ fontSize: 11 }}>Total Compras</th><th className="text-center" style={{ fontSize: 11 }}>#Suc</th><th style={{ fontSize: 11 }}>Sucursales</th><th className="text-center" style={{ fontSize: 11 }}>Tipo</th></tr>
                        </thead>
                        <tbody>
                            {detalle.map((d, i) => (
                                <tr key={i}>
                                    <td><div className="fw-bold" style={{ fontSize: 12 }}>{d.nombrereceptor}</div><small className="text-muted">{d.nitreceptor}</small></td>
                                    <td className="text-end fw-bold" style={{ fontSize: 12 }}>{fmtCur(d.total_compras)}</td>
                                    <td className="text-center"><Badge color={d.num_sucursales > 1 ? "info" : "secondary"} pill>{d.num_sucursales}</Badge></td>
                                    <td><div className="d-flex gap-1 flex-wrap">{(d.sucursales || []).map((s, si) => <Badge key={si} color="light" className="text-dark" style={{ fontSize: 10 }}>{s}</Badge>)}</div></td>
                                    <td className="text-center"><Badge color={d.tipo === "multi_sucursal" ? "success" : "warning"} pill style={{ fontSize: 10 }}>{d.tipo === "multi_sucursal" ? "Multi" : "Uni"}</Badge></td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            </CardBody></Card></Col></Row>
        </>);
    };

    // ══════════════════════════════════════════════════════════════
    //  TAB: CROSS-SELL
    // ══════════════════════════════════════════════════════════════
    const renderCrossSell = () => {
        if (!data?.oportunidades_cross_sell) return null;
        const ops = data.oportunidades_cross_sell || [];
        if (!ops.length) return <Card className="shadow-sm"><CardBody className="text-center py-4"><i className="mdi mdi-information-outline text-muted" style={{ fontSize: 40 }} /><p className="text-muted mt-2">No se encontraron oportunidades de cross-sell para los filtros seleccionados.</p></CardBody></Card>;

        // Agrupar por cliente
        const byClient = {};
        ops.forEach(o => {
            if (!byClient[o.nitreceptor]) byClient[o.nitreceptor] = { nombre: o.nombrereceptor, nit: o.nitreceptor, items: [] };
            byClient[o.nitreceptor].items.push(o);
        });
        const clients = Object.values(byClient);

        return (<>
            <Row className="mb-3"><Col>
                <Card className="shadow-sm" style={{ background: "linear-gradient(135deg,#1b5e20 0%,#388e3c 100%)" }}><CardBody className="py-3">
                    <div className="d-flex align-items-center justify-content-between flex-wrap">
                        <div className="text-white">
                            <h6 className="text-white mb-1 fw-bold"><i className="mdi mdi-swap-horizontal-bold me-2" />Oportunidades de Cross-Sell</h6>
                            <small className="text-white-50">Productos sugeridos para clientes existentes basados en patrones de consumo</small>
                        </div>
                        <div className="text-center text-white mt-2 mt-md-0">
                            <div style={{ fontSize: 10 }} className="text-white-50">OPORTUNIDADES</div>
                            <div className="fw-bold" style={{ fontSize: 24 }}>{ops.length}</div>
                        </div>
                    </div>
                </CardBody></Card>
            </Col></Row>

            {clients.map((cl, ci) => (
                <Row key={ci} className="mb-3"><Col><Card className="shadow-sm">
                    <CardHeader className="bg-white py-3" style={{ borderLeft: `4px solid ${pickColor(ci)}` }}>
                        <div className="d-flex align-items-center">
                            <i className="mdi mdi-account-circle me-2" style={{ fontSize: 22, color: pickColor(ci) }} />
                            <div><span className="fw-bold" style={{ fontSize: 14 }}>{cl.nombre}</span><small className="text-muted ms-2">NIT: {cl.nit}</small></div>
                            <Badge color="success" pill className="ms-auto">{cl.items.length} sugerencias</Badge>
                        </div>
                    </CardHeader>
                    <CardBody className="p-0">
                        <div className="table-responsive">
                            <Table size="sm" className="table-hover mb-0 align-middle">
                                <thead style={{ background: "#FAFBFC" }}>
                                    <tr><th style={{ fontSize: 11 }}>Producto Sugerido</th><th style={{ fontSize: 11 }}>Razón</th><th className="text-center" style={{ fontSize: 11 }}>Probabilidad</th></tr>
                                </thead>
                                <tbody>
                                    {cl.items.map((o, oi) => (
                                        <tr key={oi}>
                                            <td><div className="fw-bold" style={{ fontSize: 12 }}>{o.descripcion_producto}</div><small className="text-muted">Cód: {o.producto_sugerido}</small></td>
                                            <td style={{ fontSize: 12 }}>{o.razon_sugerencia}</td>
                                            <td className="text-center">
                                                <div style={{ maxWidth: 100, margin: "0 auto" }}>
                                                    <small className="fw-bold">{o.probabilidad_compra_pct}%</small>
                                                    <Progress value={o.probabilidad_compra_pct} style={{ height: 5 }} color={o.probabilidad_compra_pct >= 50 ? "success" : o.probabilidad_compra_pct >= 30 ? "warning" : "secondary"} />
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    </CardBody>
                </Card></Col></Row>
            ))}
        </>);
    };

    // ══════════════════════════════════════════════════════════════
    //  MODAL: DETALLE PRODUCTO
    // ══════════════════════════════════════════════════════════════
    const renderModalProducto = () => {
        if (!selProducto) return null;
        const p = selProducto;
        const sucVentas = p.ventas_por_sucursal || [];

        const sucBar = sucVentas.length ? {
            series: [{ name: "Ventas", data: sucVentas.map(s => Math.round(s.importe)) }],
            options: {
                chart: { type: "bar", toolbar: { show: false }, fontFamily: "inherit" },
                plotOptions: { bar: { borderRadius: 6, columnWidth: "50%", distributed: true } },
                colors: sucVentas.map((_, i) => pickColor(i)),
                xaxis: { categories: sucVentas.map(s => s.sucursal) },
                yaxis: { labels: { formatter: v => fmtCur(v) } },
                dataLabels: { enabled: true, formatter: v => fmtCur(v), style: { fontSize: "10px" }, offsetY: -20 },
                legend: { show: false },
                tooltip: { y: { formatter: v => fmtCur(v) } },
            }
        } : null;

        const sucPie = sucVentas.length ? {
            series: sucVentas.map(s => Math.round(s.importe)),
            options: {
                chart: { type: "pie", fontFamily: "inherit" },
                labels: sucVentas.map(s => s.sucursal),
                colors: sucVentas.map((_, i) => pickColor(i)),
                legend: { position: "bottom", fontSize: "11px" },
                dataLabels: { formatter: v => `${v.toFixed(1)}%`, style: { fontSize: "11px" } },
                tooltip: { y: { formatter: v => fmtCur(v) } },
            }
        } : null;

        return (
            <Modal isOpen={modal} toggle={() => setModal(false)} size="lg" scrollable>
                <ModalHeader toggle={() => setModal(false)} style={{ background: "#E3F2FD" }}>
                    <div className="d-flex align-items-center">
                        <i className="mdi mdi-package-variant-closed me-2" style={{ fontSize: 24, color: "#1976D2" }} />
                        <div><h5 className="mb-0 fw-bold">{p.descripcion}</h5><small className="text-muted">Código: {p.codigo_producto}</small></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Row className="mb-3">
                        <Col sm={4} className="mb-2"><Kpi icon="mdi-cash" title="VENTA TOTAL" value={fmtCur(p.total_general)} color="#4CAF50" /></Col>
                        <Col sm={4} className="mb-2"><Kpi icon="mdi-counter" title="CANTIDAD" value={fmtNum(p.cantidad_general)} color="#2196F3" /></Col>
                        <Col sm={4} className="mb-2"><Kpi icon="mdi-store-marker" title="SUCURSALES" value={sucVentas.length} color="#FF9800" /></Col>
                    </Row>

                    {sucBar && <Row className="mb-3">
                        <Col md={7}><Card className="shadow-sm"><CardBody>
                            <h6 className="fw-bold mb-2" style={{ fontSize: 13 }}><i className="mdi mdi-chart-bar me-1 text-primary" />Ventas por Sucursal</h6>
                            <ReactApexChart options={sucBar.options} series={sucBar.series} type="bar" height={250} />
                        </CardBody></Card></Col>
                        <Col md={5}>{sucPie && <Card className="shadow-sm"><CardBody>
                            <h6 className="fw-bold mb-2" style={{ fontSize: 13 }}><i className="mdi mdi-chart-pie me-1 text-warning" />Distribución</h6>
                            <ReactApexChart options={sucPie.options} series={sucPie.series} type="pie" height={250} />
                        </CardBody></Card>}</Col>
                    </Row>}

                    <Table size="sm" className="table-hover mb-0 align-middle">
                        <thead style={{ background: "#F5F7FA" }}>
                            <tr><th style={{ fontSize: 11 }}>Sucursal</th><th className="text-end" style={{ fontSize: 11 }}>Importe</th><th className="text-center" style={{ fontSize: 11 }}>Cantidad</th><th className="text-center" style={{ fontSize: 11 }}>Frecuencia</th><th className="text-center" style={{ fontSize: 11 }}>%</th></tr>
                        </thead>
                        <tbody>
                            {sucVentas.map((s, si) => (
                                <tr key={si}>
                                    <td className="fw-bold" style={{ fontSize: 12 }}><i className="mdi mdi-store text-primary me-1" />{s.sucursal}</td>
                                    <td className="text-end fw-bold" style={{ fontSize: 12, color: "#4CAF50" }}>{fmtCur(s.importe)}</td>
                                    <td className="text-center" style={{ fontSize: 12 }}>{fmtNum(s.cantidad)}</td>
                                    <td className="text-center" style={{ fontSize: 12 }}>{fmtNum(s.frecuencia)}</td>
                                    <td className="text-center"><div style={{ maxWidth: 80, margin: "0 auto" }}><small>{fmtPct(s.porcentaje_del_producto)}</small><Progress value={s.porcentaje_del_producto} style={{ height: 4 }} color="info" /></div></td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </ModalBody>
            </Modal>
        );
    };

    // ══════════════════════════════════════════════════════════════
    //  MODAL: DETALLE RECEPTOR (top productos)
    // ══════════════════════════════════════════════════════════════
    const renderModalReceptor = () => {
        if (!selReceptor) return null;
        const rec = selReceptor;
        const prods = rec.productos || [];

        const prodBar = prods.length ? {
            series: [{ name: "Importe", data: prods.slice(0, 10).map(p => Math.round(p.importe_total)) }],
            options: {
                chart: { type: "bar", toolbar: { show: false }, fontFamily: "inherit" },
                plotOptions: { bar: { borderRadius: 4, horizontal: true, barHeight: "65%", distributed: true } },
                colors: prods.slice(0, 10).map((_, i) => pickColor(i)),
                dataLabels: { enabled: true, formatter: v => fmtCur(v), style: { fontSize: "10px" } },
                xaxis: { categories: prods.slice(0, 10).map(p => p.descripcion.length > 25 ? p.descripcion.substring(0, 25) + "…" : p.descripcion), labels: { formatter: v => fmtCur(v) } },
                yaxis: { labels: { style: { fontSize: "10px" }, maxWidth: 180 } },
                legend: { show: false },
                tooltip: { y: { formatter: v => fmtCur(v) } },
            }
        } : null;

        return (
            <Modal isOpen={modalRec} toggle={() => setModalRec(false)} size="lg" scrollable>
                <ModalHeader toggle={() => setModalRec(false)} style={{ background: "#E8F5E9" }}>
                    <div className="d-flex align-items-center">
                        <i className="mdi mdi-account-circle me-2" style={{ fontSize: 24, color: "#2E7D32" }} />
                        <div><h5 className="mb-0 fw-bold">{rec.nombrereceptor}</h5><small className="text-muted">NIT: {rec.nitreceptor} • Total: {fmtCur(rec.total_compras)}</small></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    {prodBar && <Card className="shadow-sm mb-3"><CardBody>
                        <h6 className="fw-bold mb-2" style={{ fontSize: 13 }}><i className="mdi mdi-chart-bar me-1 text-primary" />Top Productos</h6>
                        <ReactApexChart options={prodBar.options} series={prodBar.series} type="bar" height={Math.max(250, prods.slice(0, 10).length * 35)} />
                    </CardBody></Card>}

                    <div className="table-responsive">
                        <Table size="sm" className="table-hover mb-0 align-middle">
                            <thead style={{ background: "#F5F7FA" }}>
                                <tr><th style={{ fontSize: 11 }}>#</th><th style={{ fontSize: 11 }}>Producto</th><th className="text-center" style={{ fontSize: 11 }}>Cant.</th><th className="text-end" style={{ fontSize: 11 }}>Importe</th><th className="text-center" style={{ fontSize: 11 }}>Veces</th><th className="text-center" style={{ fontSize: 11 }}>% Gasto</th></tr>
                            </thead>
                            <tbody>
                                {prods.map((p, pi) => (
                                    <tr key={pi}>
                                        <td className="fw-bold" style={{ color: pickColor(pi) }}>{pi + 1}</td>
                                        <td><div className="fw-bold" style={{ fontSize: 12 }}>{p.descripcion}</div><small className="text-muted">Cód: {p.codigo_producto}</small></td>
                                        <td className="text-center" style={{ fontSize: 12 }}>{fmtNum(p.cantidad_total)}</td>
                                        <td className="text-end fw-bold" style={{ fontSize: 12, color: "#4CAF50" }}>{fmtCur(p.importe_total)}</td>
                                        <td className="text-center" style={{ fontSize: 12 }}>{p.veces_comprado}</td>
                                        <td className="text-center"><div style={{ maxWidth: 80, margin: "0 auto" }}><small>{fmtPct(p.participacion_gasto_pct)}</small><Progress value={p.participacion_gasto_pct} style={{ height: 4 }} color="success" /></div></td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </ModalBody>
            </Modal>
        );
    };

    // ══════════════════════════════════════════════════════════════
    //  RENDER PRINCIPAL
    // ══════════════════════════════════════════════════════════════
    const selectStyles = {
        control: b => ({ ...b, minHeight: 36, fontSize: 13 }),
        option: b => ({ ...b, fontSize: 13 }),
    };

    return (
        <React.Fragment>
            <Row><Col xs={12}>
                {/* ── FILTROS ── */}
                <Card className="shadow-sm mb-3"><CardBody className="pb-2">
                    <div className="d-flex align-items-center mb-3">
                        <div style={{ width: 40, height: 40, borderRadius: "50%", background: "linear-gradient(135deg,#1b5e20 0%,#43a047 100%)", display: "flex", alignItems: "center", justifyContent: "center", marginRight: 12 }}>
                            <i className="mdi mdi-map-marker-radius" style={{ fontSize: 20, color: "#fff" }} />
                        </div>
                        <div>
                            <h5 className="mb-0 fw-bold">Mapa de Consumo</h5>
                            <small className="text-muted">Matriz producto-sucursal, concentración de ingresos y oportunidades de cross-sell</small>
                        </div>
                    </div>

                    <Form onSubmit={e => { e.preventDefault(); fetchData(); }}>
                        <Row className="align-items-end g-2">
                            <Col md={2}>
                                <FormGroup className="mb-2">
                                    <Label className="mb-1" style={{ fontSize: 12, fontWeight: 600 }}><i className="mdi mdi-domain me-1" />NIT Emisor</Label>
                                    <div style={{ padding: "6px 12px", background: "#f0f4ff", borderRadius: 6, border: "1px solid #c3cbe4", fontSize: 13, color: "#343a40", fontWeight: 600, minHeight: 36, display: "flex", alignItems: "center" }}>
                                        {nitemisor ? (
                                            <><i className="mdi mdi-check-circle text-success me-1"></i>{(() => {
                                                try {
                                                    const emp = JSON.parse(localStorage.getItem("empresaSeleccionada") || "{}")
                                                    return `${emp.nombre || ""} - ${nitemisor}`
                                                } catch (e) { return nitemisor }
                                            })()}</>
                                        ) : (
                                            <span style={{ color: "#adb5bd" }}><i className="mdi mdi-alert-circle-outline me-1"></i>Sin empresa</span>
                                        )}
                                    </div>
                                </FormGroup>
                            </Col>
                            <Col md={2}>
                                <FormGroup className="mb-2">
                                    <Label className="mb-1" style={{ fontSize: 12, fontWeight: 600 }}><i className="mdi mdi-calendar-range me-1" />Periodo</Label>
                                    <DatePicker selectsRange startDate={fechaInicio} endDate={fechaFin}
                                        onChange={u => setFechaRango(u)} dateFormat="yyyy-MM-dd"
                                        className="form-control form-control-sm" placeholderText="Inicio — Fin" isClearable />
                                </FormGroup>
                            </Col>
                            <Col md={2}>
                                <FormGroup className="mb-2">
                                    <Label className="mb-1" style={{ fontSize: 12, fontWeight: 600 }}><i className="mdi mdi-store me-1" />Sucursal</Label>
                                    <Select options={sucursalOpts} value={sucursalOpts.find(s => s.value === selectedSucursal) || sucursalOpts[0]}
                                        onChange={o => setSelectedSucursal(o ? o.value : "")} styles={selectStyles} />
                                </FormGroup>
                            </Col>
                            <Col md={2}>
                                <FormGroup className="mb-2">
                                    <Label className="mb-1" style={{ fontSize: 12, fontWeight: 600 }}><i className="mdi mdi-card-account-details me-1" />NIT Receptor</Label>
                                    <Input bsSize="sm" placeholder="Opcional…" value={nitreceptor} onChange={e => setNitreceptor(e.target.value)} style={{ height: 36, fontSize: 13 }} />
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup className="mb-2">
                                    <div className="d-flex gap-2">
                                        <Button color="primary" type="submit" disabled={loading} size="sm" className="flex-grow-1" style={{ height: 36 }}>
                                            {loading ? <><Spinner size="sm" className="me-1" /> Analizando…</> : <><i className="mdi mdi-magnify me-1" /> Analizar</>}
                                        </Button>
                                        <Button color="light" type="button" onClick={limpiar} size="sm" style={{ height: 36 }} title="Limpiar"><i className="mdi mdi-eraser" /></Button>
                                        <Button color="success" type="button" onClick={descargarExcel} disabled={loadingExcel} size="sm" style={{ height: 36 }} title="Excel">
                                            {loadingExcel ? <Spinner size="sm" /> : <><i className="mdi mdi-file-excel me-1" />Excel</>}
                                        </Button>
                                        <Button color="danger" type="button" onClick={descargarPdf} disabled={loadingPdf} size="sm" style={{ height: 36 }} title="PDF">
                                            {loadingPdf ? <Spinner size="sm" /> : <><i className="mdi mdi-file-pdf-box me-1" />PDF</>}
                                        </Button>
                                    </div>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                </CardBody></Card>

                {/* ── LOADING ── */}
                {loading && (
                    <div className="text-center py-5">
                        <Spinner color="primary" style={{ width: 48, height: 48 }} />
                        <p className="mt-3 text-muted fw-medium">Analizando mapa de consumo…</p>
                    </div>
                )}

                {/* ── EMPTY ── */}
                {!loading && !data && (
                    <Card className="shadow-sm"><CardBody className="text-center py-5">
                        <i className="mdi mdi-map-marker-radius-outline" style={{ fontSize: 60, color: "#bbb" }} />
                        <h5 className="text-muted mt-3">Mapa de Consumo</h5>
                        <p className="text-muted mb-0">Seleccione empresa y rango de fechas para analizar el consumo.</p>
                        <p className="text-muted" style={{ fontSize: 13 }}>Obtendrá la matriz producto-sucursal, concentración Pareto, cobertura geográfica y oportunidades de cross-sell.</p>
                    </CardBody></Card>
                )}

                {/* ── DATA ── */}
                {!loading && data && (<>
                    {/* Header empresa */}
                    <Card className="shadow-sm mb-3" style={{ background: "linear-gradient(135deg,#1b5e20 0%,#2e7d32 100%)" }}><CardBody className="py-3">
                        <Row className="align-items-center">
                            <Col md={6}>
                                <h5 className="text-white mb-1 fw-bold"><i className="mdi mdi-office-building me-2" />{data.nombre_emisor}</h5>
                                <small className="text-white-50">NIT: {data.nitemisor} • Periodo: {data.periodo}</small>
                            </Col>
                            <Col md={6}>
                                <div className="d-flex gap-4 justify-content-md-end mt-2 mt-md-0">
                                    {[
                                        ["PRODUCTOS", (data.matriz_producto_sucursal || []).length],
                                        ["RECEPTORES", data.cobertura_geografica?.total_receptores || 0],
                                        ["CROSS-SELL", (data.oportunidades_cross_sell || []).length],
                                    ].map(([l, v], i) => (
                                        <div className="text-center" key={i}>
                                            <div className="text-white-50" style={{ fontSize: 10 }}>{l}</div>
                                            <div className="text-white fw-bold" style={{ fontSize: 22 }}>{v}</div>
                                        </div>
                                    ))}
                                </div>
                            </Col>
                        </Row>
                    </CardBody></Card>

                    {/* Tabs */}
                    <Card className="shadow-sm"><CardBody>
                        <Nav tabs className="mb-4">
                            {[
                                ["dashboard", "mdi-view-dashboard", "Dashboard"],
                                ["matriz", "mdi-grid", "Matriz Producto-Sucursal"],
                                ["receptores", "mdi-account-group", "Top por Receptor"],
                                ["cobertura", "mdi-store-marker", "Cobertura Geográfica"],
                                ["crosssell", "mdi-swap-horizontal-bold", "Cross-Sell"],
                            ].map(([id, ic, lb]) => (
                                <NavItem key={id}><NavLink className={activeTab === id ? "active" : ""} onClick={() => setActiveTab(id)} style={{ cursor: "pointer", fontWeight: 600, fontSize: 13 }}>
                                    <i className={`mdi ${ic} me-1`} />{lb}
                                </NavLink></NavItem>
                            ))}
                        </Nav>
                        <TabContent activeTab={activeTab}>
                            <TabPane tabId="dashboard">{renderDashboard()}</TabPane>
                            <TabPane tabId="matriz">{renderMatriz()}</TabPane>
                            <TabPane tabId="receptores">{renderTopReceptores()}</TabPane>
                            <TabPane tabId="cobertura">{renderCobertura()}</TabPane>
                            <TabPane tabId="crosssell">{renderCrossSell()}</TabPane>
                        </TabContent>
                    </CardBody></Card>
                </>)}
            </Col></Row>

            {renderModalProducto()}
            {renderModalReceptor()}
        </React.Fragment>
    );
};

const mapStateToProps = (state) => ({ authData: state.Login.user, empresaSeleccionada: state.Login.empresaSeleccionada });
export default connect(mapStateToProps, { setBreadcrumbItems })(MapaConsumo);